import { useMutation } from "@tanstack/react-query";
import { useAxios } from "../";

export default function useAsset() {
    const { axiosPrivate } = useAxios();

    function useDownload() {
        return useMutation({
            mutationFn: async (params: any) => {
                const response = await axiosPrivate.get(`/v1/asset/download`, {
                    params,
                    responseType: "blob",
                });

                const filename = response.headers["file-name"] || "download-file";
                const blob = new Blob([response.data]);
                const blobUrl = window.URL.createObjectURL(blob);
                const link = document.createElement("a");

                link.href = blobUrl;
                link.download = filename;
                document.body.appendChild(link);
                link.click();

                window.URL.revokeObjectURL(blobUrl);
                document.body.removeChild(link);

                return true;
            },
        });
    }

    function useGetAsset() {
        return useMutation({
            mutationFn: async (params: any) => {
                const response = await axiosPrivate.get(`/v1/asset/download`, {
                    params,
                    responseType: "blob",
                });
                return response.data;
            },
        });
    }

    return { useDownload, useGetAsset };
}
